<template>
  <div class="container">
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
    <div class="navbar-brand nav-logo" :to="{ name: 'Main_page' }">
      <img :src='"../assets/images/logo.png"' alt="logo">
      <span class="f-color"> SISTEMAS</span>
    </div>
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
    <b-collapse class="default-nav" is-nav id="nav_collapse">
      <b-navbar-nav class="navbar-nav ml-auto" id="mymenu">
        <b-nav-item :to="{ name: 'Main_page' }">Inicio</b-nav-item>
        <b-nav-item :to="{ name: 'Main_page' }">Solução</b-nav-item>
        <b-nav-item :to="{ name: 'Main_page' }">Sistema</b-nav-item>
        <b-nav-item :to="{ name: 'Main_page' }">SEJA UM PARCEIRO</b-nav-item>
        <b-nav-item href="http://200.98.132.251/">PORTAL DO PARCEIRO</b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </div>
</template>
<script>
export default {
  name: 'Navbar',
  beforeCreate: function () {
    document.body.className = ''
  }
}
</script>
<style scoped>
.nav-logo {
  display: flex;
  align-items: flex-end;
}

.nav-logo img {
  width: 100px;
  margin-right: 10px;
}

.nav-logo span {
  line-height: 0.8;
}

.header-top-bar,
.header-top-bar i {
  color: white !important;
  padding: 5px;
}

.darkHeader.theme-nav .nav-item {
  padding: 8px 0 8px 7px !important;
}

.social-icon i {
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/navbar_more.vue